// TODO Use this instead of throw { validationError: true }
export default class ValidationError extends Error {
  validationError = true

  constructor() {
    super('Validation error')
  }
}

export function isValidationError(error: unknown): error is ValidationError {
  return (error as ValidationError)?.validationError === true
}
